@if (dashboard.open()) {
    <div class="dl-dashboardv1__paneel">
        <div class="dl-dashboardv1__kop">
            <h3>{{ 'DASHBOARD.TITEL' | translate }}
                <button type="button" class="btn-close btn-close-white float-end" aria-label="Close"
                        (click)="sluitPaneel()"></button>
            </h3>
        </div>
        <div class="dl-dashboardv1__body">
            <div class="dl-dashboardv1__controls">
                <div class="btn-group">
                    <button type="button" class="btn btn-primary" [class.active]="stand() === 'live'"
                            [disabled]="!!detail()" (click)="zetStand('live')">{{ 'DASHBOARD.LIVE' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary" [class.active]="stand() === 'alles'"
                            [disabled]="!!detail()" (click)="zetStand('alles')">{{ 'DASHBOARD.ALLES' | translate }}
                    </button>
                </div>
                <div class="dl-dashboardv1__scheiding"></div>
                <div class="btn-group">
                    @for (balk of balken; track balk.key) {
                        <button type="button" class="btn btn-primary" [class.active]="balkAan()[balk.key]"
                                (click)="toggleBalk(balk.key)">{{ balk.knop }}
                        </button>
                    }
                </div>
                <div class="dl-dashboardv1__scheiding"></div>
                <div class="dl-dashboardv1__balkcontrols">
                    @for (groep of knoppenPerBalk; track groep.balk) {
                        @if (balkAan()[groep.balk]) {
                            <div class="dl-dashboardv1__balkseries">
                                @for (serie of groep.series; track serie.seriekey) {
                                    <div class="dl-dashboardv1__serie"
                                         [class.dl-dashboardv1__serie--inactief]="verborgen().has(serie.seriekey)"
                                         [class.dl-dashboardv1__serie--tekstwit]="serie.tekstwit"
                                         [style.backgroundColor]="serie.kleur"
                                         [style.borderColor]="randkleurVan(serie)"
                                         [title]="serie.titel ?? serie.seriekey"
                                         (click)="toggleSerie(serie)">
                                        @if (serie.icoon) {
                                            <span [class]="serie.icoon"></span>
                                        } @else if (serie.svg) {
                                            <div class="dl-dashboardv1__svg dl-dashboardv1__svg--{{ serie.svg }}"></div>
                                        } @else {
                                            {{ serie.seriekey }}
                                        }
                                    </div>
                                }
                            </div>
                        }
                    }
                </div>
                <div class="dl-dashboardv1__scheiding"></div>
            </div>

            @if (detail()) {
                <div class="dl-dashboardv1__detailbrowser">
                    <div class="dl-dashboardv1__pijl" [title]="'DASHBOARD1.TITLES.VORIGE_USER' | translate"
                         (click)="zapDetailUser(-1)">
                        <span class="fa-solid fa-arrow-left"></span>
                        <span class="fa-solid fa-user"></span>
                    </div>
                    <div class="dl-dashboardv1__scheiding"></div>
                    <div class="dl-dashboardv1__pijl" [title]="'DASHBOARD1.TITLES.VORIG_MODEL' | translate"
                         (click)="zapDetail(-1)">
                        <span class="fa-solid fa-arrow-left"></span>
                        <span class="fa-solid fa-file"></span>
                    </div>
                    <div class="dl-dashboardv1__scheiding"></div>
                    <div class="dl-dashboardv1__modeltitel">{{ detailTitel() }}</div>
                    <div class="dl-dashboardv1__scheiding"></div>
                    <div class="dl-dashboardv1__pijl" [title]="'DASHBOARD1.TITLES.VOLGEND_MODEL' | translate"
                         (click)="zapDetail(1)">
                        <span class="fa-solid fa-file"></span>
                        <span class="fa-solid fa-arrow-right"></span>
                    </div>
                    <div class="dl-dashboardv1__scheiding"></div>
                    <div class="dl-dashboardv1__pijl" [title]="'DASHBOARD1.TITLES.VOLGENDE_USER' | translate"
                         (click)="zapDetailUser(1)">
                        <span class="fa-solid fa-user"></span>
                        <span class="fa-solid fa-arrow-right"></span>
                    </div>
                    <div class="dl-dashboardv1__detailsluiter">
                        <button type="button" class="btn-close"
                                [title]="'DASHBOARD1.TITLES.SLUIT_DETAIL' | translate"
                                (click)="sluitDetail()"></button>
                    </div>
                </div>
            }

            @defer (when dashboard.open()) {
                <dl-dashboardv1-grafieken
                        [barLabels]="barLabels()"
                        [barDatasets]="barDatasets()"
                        [barOpties]="barOpties"
                        [donutLabels]="donutLabels()"
                        [donutDatasets]="donutDatasets()"
                        [donutOpties]="donutOpties"
                        [breedte]="breedte()"
                        [detail]="!!detail()"
                        [detailImg]="detailImg()"
                        [dataLeeg]="dataLeeg()"
                        [magMeekijken]="magMeekijkenAan()"
                        (kiesKolom)="kiesKolom($event)"
                        (meekijken)="meekijken()"></dl-dashboardv1-grafieken>
            } @placeholder {
                <div class="dl-dashboardv1__laden"></div>
            }
        </div>
    </div>
}
